import React, { useState } from 'react'
import { NavLink, Link } from 'react-router-dom'
import { Menu, X, Phone, Mail } from 'lucide-react'

export default function Header() {
  const [isOpen, setIsOpen] = useState(false)

  const toggleMenu = () => setIsOpen(!isOpen)
  const closeMenu = () => setIsOpen(false)

  const navItems = [
    { name: 'Forside', path: '/' },
    { name: 'Vi tilbyder', path: '/jeg-tilbyder' },
    { name: 'Kontakt', path: '/kontakt' }
  ]

  return (
    <header className="sticky top-0 z-50 bg-silver-200/95 border-b border-silver-400 backdrop-blur-md shadow-sm">
      {/* Top bar for B2B trust */}
      <div className="hidden min-[1200px]:block bg-silver-300 border-b border-silver-400 py-2 px-4 md:px-8">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-slate-700 font-medium">
          <div className="flex items-center gap-2">
            <span className="inline-block h-2 w-2 rounded-full bg-amber-500 animate-pulse" />
            <span className="uppercase tracking-wider font-bold text-slate-900">Udelukkende B2B &amp; Erhverv</span>
            <span className="text-slate-400">|</span>
            <span>Vi udfører ikke arbejde for private</span>
          </div>
          <div className="flex items-center gap-4">
            <a href="tel:+4524460485" className="flex items-center gap-1 hover:text-amber-600 transition-colors duration-200 whitespace-nowrap">
              <Phone className="w-3.5 h-3.5 text-amber-600" />
              <span>(+45) 24 46 04 85</span>
            </a>
            <a href="mailto:jp@jpstaal.dk" className="flex items-center gap-1 hover:text-amber-600 transition-colors duration-200 whitespace-nowrap">
              <Mail className="w-3.5 h-3.5 text-amber-600" />
              <span>jp@jpstaal.dk</span>
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" onClick={closeMenu} className="flex items-center gap-3">
              <img
                src="https://assets.auxodev.dk/assets/e3c28b93-c07f-41a2-89fa-cab890739d18/e8092bc9-b1f6-449e-8c9a-83e82880648c.png"
                alt="JP Stål og Rør ApS Logo"
                className="h-14 md:h-18 w-auto object-contain"
              />
            </Link>
          </div>

          {/* Desktop Navigation (Visible at >= 1200px) */}
          <nav className="hidden min-[1200px]:flex items-center gap-8">
            {navItems.map((item) => (
              <NavLink
                key={item.name}
                to={item.path}
                className={({ isActive }) =>
                  `text-sm font-bold uppercase tracking-wider transition-all duration-200 py-2 border-b-2 cursor-pointer ${
                    isActive
                      ? 'text-amber-600 border-amber-600'
                      : 'text-slate-800 border-transparent hover:text-slate-950 hover:border-slate-600'
                  }`
                }
              >
                {item.name}
              </NavLink>
            ))}
            <a
              href="tel:+4524460485"
              className="bg-amber-500 hover:bg-amber-600 text-slate-950 font-black uppercase tracking-wider text-xs px-5 py-3 rounded-sm transition-colors duration-200 cursor-pointer shadow-sm"
            >
              Ring op i dag
            </a>
          </nav>

          {/* Mobile Menu Button (Visible at < 1200px) */}
          <div className="flex min-[1200px]:hidden">
            <button
              onClick={toggleMenu}
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-sm text-slate-700 hover:text-slate-950 hover:bg-silver-300 focus:outline-none transition-colors duration-200 cursor-pointer"
              aria-controls="mobile-menu"
              aria-expanded={isOpen}
            >
              <span className="sr-only">Åbn menu</span>
              {isOpen ? <X className="block h-6 w-6" /> : <Menu className="block h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu (Visible at < 1200px when open) */}
      {isOpen && (
        <div className="min-[1200px]:hidden bg-silver-300 border-t border-silver-400" id="mobile-menu">
          <div className="px-2 pt-2 pb-4 space-y-1 sm:px-3">
            {navItems.map((item) => (
              <NavLink
                key={item.name}
                to={item.path}
                onClick={closeMenu}
                className={({ isActive }) =>
                  `block px-3 py-3 rounded-sm text-base font-bold uppercase tracking-wider transition-colors duration-200 cursor-pointer ${
                    isActive
                      ? 'bg-amber-500/10 text-amber-600 border-l-4 border-amber-500 pl-2'
                      : 'text-slate-800 hover:bg-silver-400/40 hover:text-slate-950'
                  }`
                }
              >
                {item.name}
              </NavLink>
            ))}
            <div className="pt-4 pb-2 border-t border-silver-400 px-3">
              <a
                href="tel:+4524460485"
                className="block w-full bg-amber-500 hover:bg-amber-600 text-slate-950 text-center font-black uppercase tracking-wider text-sm py-3.5 rounded-sm transition-colors duration-200 cursor-pointer shadow-sm"
              >
                Ring: (+45) 24 46 04 85
              </a>
              <a
                href="mailto:jp@jpstaal.dk"
                className="block w-full border border-silver-400 bg-silver-200 hover:bg-silver-100 text-slate-900 text-center font-bold uppercase tracking-wider text-xs py-3 rounded-sm mt-2 transition-colors duration-200 cursor-pointer"
              >
                Mail: jp@jpstaal.dk
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  )
}
